import { Content, Container, BackHeader } from './styles';
import { Link, useParams } from 'react-router';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import { useTheme } from '@mui/material/styles';
import { ArrowLeft } from 'lucide-react';
import { LogoStyle } from '../Login/styles';

function ForgetPassword() {
  const params = useParams();
  const recoveryToken = params['recovery-token'];
  const theme = useTheme();

  return (
    <Container>
      <Content>
        <BackHeader>
          <Link
            to={!recoveryToken ? '/' : '/forget-password'}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ArrowLeft
              color={theme.palette.fixed.white}
              className="backButton"
            />
          </Link>
        </BackHeader>
        <LogoStyle />
        {!recoveryToken ? <StepOne /> : <StepTwo />}
      </Content>
    </Container>
  );
}
export default ForgetPassword;
